import { render, staticRenderFns } from "./ZDMEditorSettings.vue?vue&type=template&id=f9bfae3e&"
import script from "./ZDMEditorSettings.vue?vue&type=script&lang=js&"
export * from "./ZDMEditorSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports